import { useCallback } from "react";
import { axios } from "./axios";

export const useDownloadDocument = () => {
  const [state, execute, cancel] = axios<string, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({
        url: `/${id}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
